var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIlcv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27C54 41.9117 41.9117 54 27 54Z",
    fill: "#5FC79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0395 30.5215H34.2144V33.9588H5.0395V30.5215Z",
    fill: "#A37714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47662 31.5938H28.0185C29.3234 31.5938 30.3843 32.6547 30.3843 33.9596H6.10019C6.1108 32.6547 7.1717 31.5938 8.47662 31.5938Z",
    fill: "#66480C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03937 13.5156H33.27V30.5219H5.03937V13.5156Z",
    fill: "#C49622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2142 19.9766H39.4868C40.5902 19.9766 41.6086 20.5601 42.1603 21.5149L43.9108 24.5172C44.314 25.2174 44.9717 25.7267 45.7568 25.9388L48.4727 26.7027C49.8094 27.074 50.7324 28.294 50.7324 29.6838V33.9593H34.2142V19.9766Z",
    fill: "#C49622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9698 33.9598L40.6539 30.5543C40.6539 30.5543 43.7729 28.8144 47.6558 29.939L49.1411 33.9598H37.9698Z",
    fill: "#080708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.799 31.3066H51.8359V33.9483H49.799V31.3066Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6108 33.9601L47.1998 30.4273H43.476C42.0544 30.4273 40.7283 31.1381 39.9432 32.3264L38.8505 33.9601H36.9196L38.5004 31.6898C39.5613 30.1409 41.3224 29.2285 43.2002 29.2285H48.1864L49.8521 33.9601H48.6108Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.629 40.494C20.2619 40.494 18.3429 38.575 18.3429 36.2079C18.3429 33.8408 20.2619 31.9219 22.629 31.9219C24.9961 31.9219 26.915 33.8408 26.915 36.2079C26.915 38.575 24.9961 40.494 22.629 40.494Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6291 38.7544C21.2229 38.7544 20.083 37.6145 20.083 36.2083C20.083 34.8021 21.2229 33.6621 22.6291 33.6621C24.0353 33.6621 25.1753 34.8021 25.1753 36.2083C25.1753 37.6145 24.0353 38.7544 22.6291 38.7544Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6289 37.3331C22.0078 37.3331 21.5043 36.8296 21.5043 36.2085C21.5043 35.5875 22.0078 35.084 22.6289 35.084C23.2499 35.084 23.7534 35.5875 23.7534 36.2085C23.7534 36.8296 23.2499 37.3331 22.6289 37.3331Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5719 40.494C10.2047 40.494 8.28581 38.575 8.28581 36.2079C8.28581 33.8408 10.2047 31.9219 12.5719 31.9219C14.939 31.9219 16.8579 33.8408 16.8579 36.2079C16.8579 38.575 14.939 40.494 12.5719 40.494Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5715 38.7544C11.1653 38.7544 10.0253 37.6145 10.0253 36.2083C10.0253 34.8021 11.1653 33.6621 12.5715 33.6621C13.9777 33.6621 15.1177 34.8021 15.1177 36.2083C15.1177 37.6145 13.9777 38.7544 12.5715 38.7544Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5717 37.3331C11.9507 37.3331 11.4472 36.8296 11.4472 36.2085C11.4472 35.5875 11.9507 35.084 12.5717 35.084C13.1928 35.084 13.6963 35.5875 13.6963 36.2085C13.6963 36.8296 13.1928 37.3331 12.5717 37.3331Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5608 40.4848C41.0355 40.4848 38.9883 38.4377 38.9883 35.9123C38.9883 33.387 41.0355 31.3398 43.5608 31.3398C46.0861 31.3398 48.1333 33.387 48.1333 35.9123C48.1333 38.4377 46.0861 40.4848 43.5608 40.4848Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5609 38.6271C42.061 38.6271 40.845 37.4112 40.845 35.9112C40.845 34.4113 42.061 33.1953 43.5609 33.1953C45.0609 33.1953 46.2769 34.4113 46.2769 35.9112C46.2769 37.4112 45.0609 38.6271 43.5609 38.6271Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9537 21.0156C40.5159 21.1429 41.0146 21.5036 41.3116 22.0129L43.0621 25.0152C43.1576 25.185 43.2637 25.3335 43.3804 25.482H41.1949L39.9537 21.0156Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3381 20.9629L40.6006 25.4823H35.2006V20.9629H39.3381Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2702 13.5156H34.2144V30.5219H33.2702V13.5156Z",
    fill: "#A37714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5617 13.5156H32.1982V30.5219H31.5617V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0153 13.5156H29.6519V30.5219H29.0153V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4694 13.5156H27.106V30.5219H26.4694V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.923 13.5156H24.5596V30.5219H23.923V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3771 13.5156H22.0137V30.5219H21.3771V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8307 13.5156H19.4673V30.5219H18.8307V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2848 13.5156H16.9214V30.5219H16.2848V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7492 13.5156H14.3857V30.5219H13.7492V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2028 13.5156H11.8394V30.5219H11.2028V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65691 13.5156H9.29346V30.5219H8.65691V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11053 13.5156H6.74707V30.5219H6.11053V13.5156Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.257 37.7839C49.951 37.7839 49.7029 37.5358 49.7029 37.2298C49.7029 36.9238 49.951 36.6758 50.257 36.6758C50.563 36.6758 50.811 36.9238 50.811 37.2298C50.811 37.5358 50.563 37.7839 50.257 37.7839Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1757 36.6487C50.9965 36.6487 50.8513 36.5034 50.8513 36.3243C50.8513 36.1452 50.9965 36 51.1757 36C51.3548 36 51.5 36.1452 51.5 36.3243C51.5 36.5034 51.3548 36.6487 51.1757 36.6487Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3241 38.5002C49.145 38.5002 48.9998 38.355 48.9998 38.1759C48.9998 37.9968 49.145 37.8516 49.3241 37.8516C49.5032 37.8516 49.6484 37.9968 49.6484 38.1759C49.6484 38.355 49.5032 38.5002 49.3241 38.5002Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3241 36.6487C49.145 36.6487 48.9998 36.5034 48.9998 36.3243C48.9998 36.1452 49.145 36 49.3241 36C49.5032 36 49.6484 36.1452 49.6484 36.3243C49.6484 36.5034 49.5032 36.6487 49.3241 36.6487Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1757 38.5002C50.9965 38.5002 50.8513 38.355 50.8513 38.1759C50.8513 37.9968 50.9965 37.8516 51.1757 37.8516C51.3548 37.8516 51.5 37.9968 51.5 38.1759C51.5 38.355 51.3548 38.5002 51.1757 38.5002Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.625 36C44.625 36.6213 44.1213 37.125 43.5 37.125C42.8787 37.125 42.375 36.6213 42.375 36C42.375 35.3787 42.8787 34.875 43.5 34.875C44.1213 34.875 44.625 35.3787 44.625 36Z",
    fill: "#4F5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "matrix(-1 0 0 1 54 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIlcv);
export default __webpack_public_path__ + "static/media/Vehicle-ILCV.abcfc1a5844d4e3522733624f924c94b.svg";
export { ForwardRef as ReactComponent };